export interface FetchSitecoreLayoutParams {
  signal?: AbortSignal;
}

export interface FetchSitecoreLayoutResult {
  data: unknown | null;
  error: Error | null;
}

export async function fetchSitecoreLayout(
  params: FetchSitecoreLayoutParams = {}
): Promise<FetchSitecoreLayoutResult> {
  const { signal } = params;

  try {
    const url = process.env.NEXT_PUBLIC_SITECORE_LAYOUT_URL!;

    const response = await fetch(url, {
      headers: {
        Accept: "application/json",
      },
      credentials: "include",
      signal,
    });

    if (!response.ok) {
      throw new Error(
        `Failed to fetch Sitecore layout: ${response.status} ${response.statusText}`
      );
    }

    const data: unknown = await response.json();

    return {
      data,
      error: null,
    };
  } catch (error) {
    return {
      data: null,
      error:
        error instanceof Error ? error : new Error("Unknown error occurred"),
    };
  }
}
